import { Table as MuiTable, TableContainer } from "@mui/material";
import TableHeader from "./components/TableHeader";
import TableBody from "./components/TableBody";
import TableFooter from "./components/TableFooter";

const tableContainerSx = {
  overflowX: "auto",
};

function Table() {
  return (
    <TableContainer sx={tableContainerSx}>
      {/* <SpecificSweepAmount />
      <br /> */}
      <MuiTable>
        <TableHeader />
        <TableBody />
        <TableFooter />
      </MuiTable>
    </TableContainer>
  );
}

export default Table;
